'use strict';

export const funcUrl = 'https://asap-pub-api-sb.azurewebsites.net/api';                   // Azure Functions-based API
//
export const mainUIUrl = 'http://assmtappeals.azurewebsites.net/';

export const versionNum = '2.1.0';
export const auditFlag = false;  // determine if calls to doAudit method, in UtilitiesService class, will send messages to console.log
export let isParodanTestSystem = false;        // defines if connecting to Parodan TEST environment
export let localApiEnv = 0;    // calls to API are to published site (=0) or to a locally running process (=1: Rider, =2: VS Code, =3: Visual Studio)
// Set environment, i.e. if we're running against the TEST system, return the corresponding Urls
export function setEnv(): any {
  let envObj = {
    funcUrl,
    mainUIUrl,
    auditFlag,
    versionNum,
  };
  if (isParodanTestSystem) {
    envObj = {
      funcUrl: 'https://asap-pub-api-tst.azurewebsites.net/api',                 // TEST parodan sb func api
      mainUIUrl: 'https://appealsmgr-sb-test.azurewebsites.net',
      auditFlag: true,
      versionNum
    };
  }
  if (localApiEnv === 1) {
    envObj.funcUrl = 'http://localhost:7071/api';   // we're running API locally, in Rider
  } else if (localApiEnv === 2) {
    envObj.funcUrl = 'http://localhost:5001/api';   // we're running API locally, in VS Code
  } else if (localApiEnv === 3) {
    envObj.funcUrl = 'http://localhost:7031/api';   // we're running API locally, in Visual Studio
  }
  return envObj;
}
